module.exports = __webpack_public_path__ + "img/sixpackcarrier66.f3303548.jpg";